import { render } from "./GalleryOverlay.vue?vue&type=template&id=46a1784c&scoped=true&ts=true"
import script from "./GalleryOverlay.vue?vue&type=script&lang=ts"
export * from "./GalleryOverlay.vue?vue&type=script&lang=ts"

import "./GalleryOverlay.vue?vue&type=style&index=0&id=46a1784c&lang=scss"
import "./GalleryOverlay.vue?vue&type=style&index=1&id=46a1784c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a1784c"]])

export default __exports__